import { useCallback, useMemo } from "react";
import { IconBan, IconSend } from "@tabler/icons-react";

export type HeldEmailRowAction = "release" | "cancel";
const DETAILS = {
  release: { label: "Release", icon: IconSend },
  cancel: { label: "Cancel", icon: IconBan },
} as const;

export function useHeldEmailRowAction(
  action: HeldEmailRowAction,
  id: string,
  onAction: (ids: string[]) => void
) {
  const detail = useMemo(() => DETAILS[action], [action]);
  const handleClick = useCallback(() => onAction([id]), [id, onAction]);
  return { detail, handleClick };
}
